export const OPTIONS = {
  support: 'support',
  pay: 'pay',
  coupon: 'coupon',
  recharge: 'recharge'
};

export const defaultOption = OPTIONS.support;
